// Catalog exports and optionsSource resolver
export type { CatalogOption } from './countries';
export type { CityOption } from './cities';
export { countries } from './countries';
export { cities, getCitiesByCountryCodes } from './cities';

import type { CatalogOption } from './countries';
import { countries } from './countries';

// Resolves an optionsSource string to its static option list
// Returns undefined for dynamic sources like "cities" (resolved separately)
export function resolveOptionsSource(source: string): CatalogOption[] | undefined {
  switch (source) {
    case 'countries':
      return countries;
    case 'cities':
      return []; // cities resolved dynamically via getCitiesByCountryCodes
    default:
      return undefined;
  }
}
